import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import SettingStore from '../../stores/SettingStore';
import DetailView from '../Common/DetailView';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';


import MyTrainingWidget from './MyTrainingWidget';
import MySkillContainer from './MySkillContainer';
import MyModuleContainer from './MyModuleContainer';
import { MyComplianceContainer }  from '../Compliance/ComplianceContainer';

import buildContextMenu from '../Common/BuildContextMenu';

import StatStore from '../../stores/StatStore';
import { StatTypes } from '../../constants/CentricConstants';
import ModuleActions from '../../actions/ModuleActionCreator';
import CourseActions from '../../actions/CourseActionCreator';

const getActions = () => [

    {
        link: '/dashboard/mytraining/courses',
        icon: <SchoolIcon />,
        label: 'My courses',
    },
    {
        link: '/dashboard/mytraining/modules',
        icon: <ModuleIcon />,
        label: 'My modules',
    },
    {
        link: '/dashboard/mytraining/resources',
        icon: <LibraryIcon />,
        label: 'My resources',
    },
    {
        link: '/dashboard/mytraining/activities',
        icon: <ActivityIcon />,
        label: 'My Activities',
    },
    {
        type:'divider'
    },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

class MyTraining extends Component {

    constructor() {
        super(...arguments);
        this.actions = buildContextMenu(getActions());
    }

    componentDidMount() {
        ModuleActions.getMyResourceStats();
        CourseActions.getMyEnrolmentStats();
    }

    render() {
        const showMyTrainingWidget = (this.state.myEnrolmentStats.length || this.state.myResourceStats.length || this.state.compliance && this.state.compliance.length);

        const showStats = (this.state.siteKey !== 'NOSTATS');

        return (
            <DetailView title='My training' actions={this.actions}>
                <div className='cent-cards'>
                    <div className="cent-col-1" key="MyComplianceContainer">
                            <MyComplianceContainer />
                            <MySkillContainer
                                userId={this.context.auth.identity.id} />
                    </div>

                    {showStats && showMyTrainingWidget && (
                        <div className="cent-col-1" key="MyTrainingWidget">
                            <MyTrainingWidget
                                courseEnrolments={this.state.myEnrolmentStats}
                                resourceEnrolments={this.state.myResourceStats}
                            />
                        </div>
                    )}

                    {showStats && (
                        <div className="cent-col-2" key="MyModuleContainer">
                                <MyModuleContainer
                                    completed={false}
                                    userId={this.context.auth.identity.id} />
                        </div>
                    )}

                    {showStats && (
                        <div className="cent-col-2" key="MyModuleContainer_2">
                                <MyModuleContainer
                                    completed
                                    userId={this.context.auth.identity.id} />
                        </div>
                    )}

                </div>

            </DetailView>
        )
    }
}

const sanitiseStats = (stats) => ({
    myEnrolmentStats:   stats.get(StatTypes.MY_ENROLMENTS) || [],
    myResourceStats:    stats.get(StatTypes.MY_RESOURCE_STATS) || [],
});

MyTraining.getStores = () => ([StatStore, SettingStore]);
MyTraining.calculateState = (prevState) => {
    return ({
        ...sanitiseStats(StatStore.getState()),
        siteKey: SettingStore.getValue('CENTRIC_SITE_KEY')
    });
};

MyTraining.contextTypes = {
    auth: PropTypes.shape({
        identity: PropTypes.shape({
            id: PropTypes.number.isRequired
        })
    }).isRequired
};

export default Container.create(MyTraining, {withProps: true});
